import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";


export interface SeguimientoPlanRefuerzoPayload {
  id_accion_refuerzo: number;
  fecha_seguimiento: string;
  cumplido: boolean;
  observacion?: string | null;
  responsable_seguimiento?: string | null;
}

@Injectable({ providedIn: "root" })
export class SeguimientoPlanRefuerzoService {
  private readonly baseUrl = `${environment.apiUrl}/api/seguimiento_plan_refuerzo`;

  constructor(private http: HttpClient) {}

  getByAccion(idAccion: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/accion/${idAccion}`);
  }

  create(payload: SeguimientoPlanRefuerzoPayload): Observable<any> {
    return this.http.post(this.baseUrl, payload);
  }

  update(id: number, payload: SeguimientoPlanRefuerzoPayload): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}`, payload);
  }

  inactivar(id: number): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}/inactivar`, {});
  }

  activar(id: number) {
  return this.http.put(`${this.baseUrl}/${id}/activar`, {});
}
}